// extracted by mini-css-extract-plugin
export default {"visualInfo":"VisualInfo_visualInfo__PDtCR","visualInfo__text":"VisualInfo_visualInfo__text__7JHcj","visualInfo__dot":"VisualInfo_visualInfo__dot__VqRz8"};